import type { FaqItem } from '../../content/types';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

interface FaqAccordionProps {
  items: FaqItem[];
  type?: 'single' | 'multiple';
  maxItems?: number;
}

export function FaqAccordion({ items, type = 'single', maxItems }: FaqAccordionProps): JSX.Element {
  const activeItems = typeof maxItems === 'number' ? items.slice(0, maxItems) : items;

  return (
    <Accordion type={type} collapsible className="w-full">
      {activeItems.map((item, index) => (
        <AccordionItem key={item.question} value={`${item.question}-${index}`}>
          <AccordionTrigger>{item.question}</AccordionTrigger>
          <AccordionContent>
            <div className="space-y-2">
              <p>{item.answer}</p>
              <p className="text-xs font-semibold uppercase tracking-wide text-[color:var(--color-muted)]">{item.sourceStatus}</p>
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
